import { useCallback } from 'react';
import { useWorkspaceContext } from '../../providers/WorkspaceProvider/Workspace.context';
import { ChallengeCenterService } from './ChallengeCenter.service';
import { tUiSignalKey } from './ChallengeCenter.types';

/**
 * Centro de Retos (AGI-498). Two missions complete on something only the
 * browser sees: a stage change being saved (`review_stages`, reported by the
 * pipe hook after the funnel PUT succeeds) and Meta showing the business
 * verified (`verify_portfolio`). The product component that
 * witnesses it calls `useChallengeSignal()` and reports the key; nothing
 * else about that component changes.
 *
 * The switch below is what keeps this from costing every workspace on the
 * platform a request: the chip (useChallengeCenter) turns it on only when
 * the workspace is eligible and has an open week, so outside the rollout the
 * report is a no-op in the browser and never reaches the network.
 */
let signalsEnabled = false;

export function setChallengeSignalsEnabled(enabled: boolean): void {
  signalsEnabled = enabled;
}

export function areChallengeSignalsEnabled(): boolean {
  return signalsEnabled;
}

export function useChallengeSignal(): (key: tUiSignalKey) => void {
  const { currentWorkspaceId } = useWorkspaceContext();

  return useCallback(
    (key: tUiSignalKey) => {
      if (!signalsEnabled || !currentWorkspaceId) return;
      // Fire and forget: the completion comes back through the live update
      // (workspace.challenge.updated) like every other mission.
      ChallengeCenterService.signal(currentWorkspaceId, key).catch(() => undefined);
    },
    [currentWorkspaceId],
  );
}
